import { TOKEN_EXPIRE } from "../constants/messages";
// import { toast } from 'react-toastify';

import Cookies from "universal-cookie";
import {
  getCookie,
  getEncryptedCookie,
  removeCookie,
  removeEncryptedCookie,
  saveTokenData,
  secureStorage,
  setEncryptedCookie,
} from "../helper/helpers";
import { pathOr } from "ramda";
import socketService from "../helper/socketService";
import { TOKEN_NAMES, TOKEN_EXPIRY } from "../constants/constants";

const cookies = new Cookies();

class LoginService {
  doLogin(tokenData, username, password) {
    const flag = tokenData && tokenData.userTexting ? false : true;
    cookies.set("restricted", flag, {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });

    localStorage.setItem("restricted", flag);
    if (["CL", "CA", "BA", "HA", "CR"].includes(tokenData.roles.roleKey)) {
      setEncryptedCookie(TOKEN_NAMES.FE, tokenData);
      saveTokenData(tokenData);
      secureStorage.setItem(TOKEN_NAMES.FE, tokenData);
      secureStorage.setItem("username", username);
      secureStorage.setItem("password", password);
      socketService.init();

      removeCookie(TOKEN_NAMES.OTP);
      removeCookie(TOKEN_NAMES.RESEND);
      localStorage.removeItem(TOKEN_NAMES.OTP);
    } else {
      removeCookie(TOKEN_NAMES.OTP);
      removeCookie(TOKEN_NAMES.RESEND);
      return false;
    }
  }

  doAdminLogin(tokenData, username, password) {
    const flag = tokenData && tokenData.userTexting ? false : true;
    cookies.set("restricted", flag, {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });

    localStorage.setItem("restricted", flag);
    if (["OU", "TS"].includes(tokenData.roles.roleKey)) {
      setEncryptedCookie(TOKEN_NAMES.FE, tokenData);
      saveTokenData(tokenData);
      secureStorage.setItem(TOKEN_NAMES.FE, tokenData);
      secureStorage.setItem("username", username);
      secureStorage.setItem("password", password);
      socketService.init();

      removeCookie(TOKEN_NAMES.MS_LOGIN);
      removeCookie(TOKEN_NAMES.OTP);
      removeCookie(TOKEN_NAMES.RESEND);
      localStorage.removeItem(TOKEN_NAMES.OTP);
    } else {
      removeCookie(TOKEN_NAMES.OTP);
      removeCookie(TOKEN_NAMES.RESEND);
      return false;
    }
  }

  updateToken(token, username, password) {
    this.doLogin(token, username, password);
  }

  getToken() {
    let token;
    try {
      token = getEncryptedCookie(TOKEN_NAMES.FE);
      if (!token) {
        token = secureStorage.getItem(TOKEN_NAMES.FE);
      }
    } catch (e) {
      console.error(e);
    }

    return token;
  }

  getDecodedToken() {
    const token = this.getUser();
    return {
      payload: token,
    };
  }

  getTextingNumber() {
    const decodedToken = this.getDecodedToken();
    return (
      decodedToken &&
      decodedToken.payload &&
      decodedToken.payload.liveChatNumber
    );
  }

  getRcsChannelName() {
    const decodedToken = this.getDecodedToken();
    if (
      decodedToken &&
      decodedToken?.payload &&
      decodedToken?.payload?.practice?.enableRcs &&
      decodedToken?.payload?.isRcsForLivechat &&
      decodedToken?.payload?.practice?.rcsChannelName
    ) {
      return decodedToken?.payload?.practice?.rcsChannelName;
    }
    return null;
  }
  getEnableRcs() {
    const decodedToken = this.getDecodedToken();
    return decodedToken?.payload?.practice?.enableRcs === 1 ? true : false;
  }

   getEnableTranslation() {
    const decodedToken = this.getDecodedToken();
    return decodedToken?.payload?.isTranslationEnabledForLivechat ;
  }
  getIsRcsForLiveChat() {
    const decodedToken = this.getDecodedToken();
    if (
      decodedToken &&
      decodedToken?.payload &&
      decodedToken?.payload?.practice?.enableRcs &&
      decodedToken?.payload?.isRcsForLivechat
    ) {
      return decodedToken?.payload?.isRcsForLivechat;
    }
    return null;
  }

  getEhrName() {
    const decodedToken = this.getDecodedToken();
    return (
      decodedToken &&
      decodedToken.payload &&
      decodedToken.payload.practice &&
      decodedToken.payload.practice.ehrName
    );
  }

  getUser() {
    const userData = getEncryptedCookie(TOKEN_NAMES.FE);
    return userData;
  }

  getPracticeId() {
    const decodedToken = this.getDecodedToken();
    return (
      decodedToken && decodedToken.payload && decodedToken.payload.practiceId
    );
  }

  isLoggedin() {
    if (this.getToken()) {
      socketService.init();
      return true;
    }
    return false;
  }

  deleteCookie() {
    removeCookie(TOKEN_NAMES.TOKEN);
    removeCookie(TOKEN_NAMES.MS);
    removeCookie(TOKEN_NAMES.OTP);
    removeCookie(TOKEN_NAMES.MS_LOGIN);
    removeCookie("urlId");
    removeCookie("permissions");
    removeCookie("sessionEmail");
    removeCookie("sessionUserName");
    removeCookie("tokenExpiry");
    removeEncryptedCookie(TOKEN_EXPIRY);
    removeEncryptedCookie(TOKEN_NAMES.FE);
    removeCookie(TOKEN_NAMES.RESEND);
    socketService.disconnect();
    localStorage.clear();
  }

  Logout() {
    let logoutFlag = cookies.get("logoutFlag", {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });
    if (!logoutFlag) {
      logoutFlag = localStorage.getItem("logoutFlag");
    }
    if (logoutFlag) {
      this.deleteCookie();
    } else if (!logoutFlag) {
      this.deleteCookie();
    } else {
      console.log(TOKEN_EXPIRE);
      // toast.error(TOKEN_EXPIRE, { position: toast.POSITION.TOP_RIGHT });
      this.deleteCookie();
    }
  }

  doLogoutEpic() {
    cookies.set("logoutFlag", "logoutFlag", {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });
    localStorage.setItem("logoutFlag", "logoutFlag");
  }

  getName() {
    const data = this.getDecodedToken();
    if (data) {
      return data.payload?.name;
    }
    return getCookie("sessionUserName");
  }
  getEmail() {
    const data = this.getDecodedToken();
    if (data) {
      return data.payload.email;
    }
    return getCookie("sessionEmail");
  }

  getAccountName() {
    const data = this.getDecodedToken();
    if (data) {
      const practiceId = pathOr(null, ["payload", "practice", "ehrName"], data);
      return practiceId;
    }
  }

  getRoleKey() {
    const data = this.getDecodedToken();
    if (data) {
      const roleKey = pathOr(null, ["payload", "roles", "roleKey"], data);
      return roleKey;
    }
  }

  setPracticeId(practiceId) {
    cookies.set("urlId", practiceId, {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });
    localStorage.setItem("urlId", practiceId);
  }
  getUrlId() {
    let code = cookies.get("urlId", {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });
    if (!code) {
      code = localStorage.getItem("urlId");
    }

    return code;
  }
  getUserRestriction() {
    let restrictFlag = cookies.get("restricted", {
      path: "/",
      sameSite: "none",
      secure: true,
      httpOnly: true,
    });
    if (!restrictFlag) {
      restrictFlag = localStorage.getItem("restricted");
    }

    return restrictFlag;
  }
}

const loginService = new LoginService();
export default loginService;
